/** Whether or not touch gestures are supported by the browser. */
export var touch = 'ontouchstart' in window ||
    (navigator.msMaxTouchPoints ? true : false) ||
    false;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/_modules/support.js
// module id = 8
// module chunks = 0